module.exports = __webpack_public_path__ + "static/media/galerija_2017 (27).cc2ca091.jpg";